import { i18n } from '@lingui/core'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { AppHeader } from '@/@bothrs-ui/web/components/navigation/header/AppHeader'
import { globalDefinitions } from '@/defined-translations'
import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import { RichText } from '../../components/RichText'
import { VideoPlayer } from '../../components/VideoPlayer'
import { useContentById } from '../../hooks/useContent'

type Props = {
  preview?: boolean
  draft?: boolean
}

export const VideoDetailPage = ({ preview, draft }: Props) => {
  const [start, setStart] = useState(false)
  const { id } = useParams()
  const navigate = useNavigate()

  const { data: videoContent, isLoading } = useContentById(id, draft)
  // Hide navigation on native devices
  useHideNativeNavigation()

  const resolvedUrl = videoContent?.embed?.url || videoContent?.video?.url

  if (isLoading) {
    return (
      <ContentPageLayout
        header={
          <AppHeader
            primaryAction={
              preview
                ? undefined
                : {
                    label: i18n._(globalDefinitions.goBack),
                    icon: ['far', 'chevron-left'],
                    onClick: () => navigate(-1),
                  }
            }
            title={{
              title: videoContent?.title || '',
              as: 'h4',
            }}
          />
        }
      >
        <StContentContainer>
          <AnimatedLoader />
        </StContentContainer>
      </ContentPageLayout>
    )
  }

  if (!resolvedUrl) {
    return null
  }

  return (
    <ContentPageLayout
      showHeaderAlways={true}
      header={
        <AppHeader
          primaryAction={
            preview
              ? undefined
              : {
                  label: i18n._(globalDefinitions.goBack),
                  icon: ['far', 'chevron-left'],
                  onClick: () => navigate(-1),
                }
          }
          title={{
            title: videoContent?.title || '',
            as: 'h3',
          }}
        />
      }
    >
      <StContentContainer>
        <StyledVideoContainer>
          <VideoPlayer
            title={videoContent?.title}
            videoUrl={resolvedUrl}
            posterUrl={videoContent.featuredImage?.url}
            start={start}
            setStart={(start) => setStart(start)}
            onClose={() => {
              setStart(false)
            }}
          />
        </StyledVideoContainer>

        {videoContent?.contentBlocks ? <RichText contentBlocks={videoContent.contentBlocks} /> : null}
      </StContentContainer>
    </ContentPageLayout>
  )
}

const StContentContainer = styled.div`
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4} 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space6};
`
const StyledVideoContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
